import { render, staticRenderFns } from "./addAgentsDialog.vue?vue&type=template&id=27b79ed6&scoped=true&"
import script from "./addAgentsDialog.vue?vue&type=script&lang=js&"
export * from "./addAgentsDialog.vue?vue&type=script&lang=js&"
import style0 from "./addAgentsDialog.vue?vue&type=style&index=0&id=27b79ed6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b79ed6",
  null
  
)

component.options.__file = "addAgentsDialog.vue"
export default component.exports